import { Grid, styled, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { isMobileDevice } from "../../../commons/utils";
import { Columns } from "..";
import { ExPaper } from "../../../components/Paper";
import { DataTable } from "../../../components/DataTable";
import moment from "moment";
import AreaChart from "../../../charts/area";

const ToggleButtonSt = styled(ToggleButton)({
    paddingRight: '16px',
    paddingLeft: '16px',
    '&:hover': {
        backgroundColor: '#00141430',
    },
    "&.Mui-selected, &.Mui-selected:hover": {
        color: "white",
        backgroundColor: '#001414'
    }
})

const columns = [
    { field: 'grudescricao', header: 'Empresa', style: { width: window.innerWidth, whiteSpace: 'pre-wrap' } },
    { field: 'countusers', header: 'Usuários', dataType: 'numeric' },
    { field: 'count7', header: 'Semana', dataType: 'numeric' },
    { field: 'count30', header: 'Mês', dataType: 'numeric' },
    { field: 'count90', header: '90 dias', dataType: 'numeric' },
];

const columnsAnom = [
    { field: 'grudescricao', header: 'Empresa', style: { width: window.innerWidth, whiteSpace: 'pre-wrap' } },
    { field: 'countanom', header: 'Anomalias', dataType: 'numeric' },
    { field: 'count7', header: 'Semana', dataType: 'numeric' },
    { field: 'count30', header: 'Mês', dataType: 'numeric' },
    { field: 'count90', header: '90 dias', dataType: 'numeric' },
];

export const DashAnomalias = forwardRef((props: any, ref) => {
    const [originData, setOriginData] = useState<any[]>([]);
    const [usuariosData, setUsuariosData] = useState<any[]>([])
    const [anomaliasData, setAnomaliasData] = useState<any[]>([])
    const [periodo, setPeriodo] = useState<string>('3m')

    const refMovimento = useRef<any>(null);

    useEffect(() => {
        populateChart(originData);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [periodo]);

    useImperativeHandle(ref, () => ({
        setData
    }));

    function setData(_anomalias: any, _usuarios: any) {
        setOriginData(_anomalias);
        setUsuariosData(_usuarios)

        var anomSummary: any = {}
        console.log(_anomalias[0])
        _anomalias.forEach((e: any) => {
            const current = anomSummary[e.grudescricao] || { countanom: 0, count7: 0, count30: 0, count90: 0 }
            const n = parseInt(e.countanom)

            anomSummary[e.grudescricao] = {
                grudescricao: e.grudescricao,
                countanom: current.countanom + n,
                count7: current.count7 + (moment(new Date()).diff(moment(e.anomdata), 'days') <= 7 ? n : 0),
                count30: current.count30 + (moment(new Date()).diff(moment(e.anomdata), 'days') <= 30 ? n : 0),
                count90: current.count90 + (moment(new Date()).diff(moment(e.anomdata), 'days') <= 90 ? n : 0),
            }
            console.log(anomSummary)
        })

        setAnomaliasData(Object.values(anomSummary))
        populateChart(_anomalias)
    }

    const getValue = (groupByKey: string | ((item: any) => string), item: any) => typeof groupByKey === 'function' ? groupByKey(item) : item[groupByKey] || 'Não Informado'

    const groupData = (data: any[], groupByKey: string | ((item: any) => string)) => {
        const preGroup = groupDataArr(data, groupByKey)

        const reduced: any = {}
        Object.entries(preGroup).forEach(([key, val]) => reduced[key] = val.reduce((s, e) => s + parseFloat(parseFloat((e.countanom || 0)).toFixed(2)), 0))

        return reduced
    }

    const groupDataArr = (data: any[], groupByKey: string | ((item: any) => string), media?: boolean) =>
        data.reduce((acc: Record<string, any[]>, item: any) => {
            const key = getValue(groupByKey, item);
            if (!acc[key]) acc[key] = []
            acc[key] = [...acc[key], item];
            return acc;
        }, {});

    function periodFilter(element: any) {
        if (moment(element.anomdata).isAfter(moment(new Date()))) return false

        switch (periodo) {
            case 'year':
                return moment(element.anomdata).isAfter(moment().startOf('year'))
            case '3m':
                return moment(element.anomdata).isAfter(moment().subtract(3, 'months'))
            case '1m':
                return moment(element.anomdata).isAfter(moment().subtract(1, 'months'))
            case '1d':
                return moment(element.anomdata).isSameOrAfter(moment().startOf('day'))
            default:
                return true
        }
    }

    const populateChart = (data: any) => {
        const _data = data.filter(periodFilter)

        const dataGroup = groupData(_data.map((e: any) => ({ ...e, data: moment(e.anomdata).startOf('day').toDate() })), 'data')

        const valores: any = Object.values(dataGroup) // dataGroup.map((item: any) => parseFloat((item.count || 0).toFixed(2)));
        const dias = 14
        const valoresMM = valores.map((e: any, idx: number, arr: any) => idx < dias ? null : (arr.slice(idx - dias, idx).reduce((s: any, e: any) => s + e, 0) / dias))
        const descricoes = Object.keys(dataGroup).map(e => moment(e).toDate().getTime()) //dataGroup.map((item: any) => item?.data);

        const getNextMultipleOf100 = (value: number) => { return Math.ceil(value / 100) * 100 };

        refMovimento?.current.setOptions(descricoes, getNextMultipleOf100(Math.max(Math.max(...valores), 0)), 'Anomalias', false, undefined, false, undefined, 'datetime');
        refMovimento?.current.setSeries([{ name: 'Anomalias', type: "area", data: valores }, { name: 'Média Móvel (' + dias + ' dias)', type: "line", data: valoresMM }]);
    }

    const handlePeriodo = (e: any, value: any) => {
        setPeriodo(value)
    }

    return (
        <Grid container spacing={4} sx={{ padding: isMobileDevice() ? '1rem' : '1rem 4rem', paddingTop: '32px' }}>
            <Grid item xs={12}>
                <ToggleButtonGroup
                    value={periodo}
                    exclusive
                    color="primary"
                    onChange={handlePeriodo}
                >
                    <ToggleButtonSt value="all"  >
                        Tudo
                    </ToggleButtonSt>
                    <ToggleButtonSt value="year"  >
                        Ano
                    </ToggleButtonSt>
                    <ToggleButtonSt value="3m">
                        3 Meses
                    </ToggleButtonSt>
                    <ToggleButtonSt value="1m" >
                        Mês
                    </ToggleButtonSt>
                    <ToggleButtonSt value="1d">
                        Dia
                    </ToggleButtonSt>
                </ToggleButtonGroup>
            </Grid>
            <Grid item xs={12}>
                <AreaChart ref={refMovimento} />
            </Grid>
            <Grid item xs={6}>
                <ExPaper>
                    <DataTable value={usuariosData} originvalues={usuariosData} disabledrefresh={true}>
                        {Columns(columns)}
                    </DataTable>
                </ExPaper>
            </Grid>
            <Grid item xs={6}>
                <ExPaper>
                    <DataTable value={anomaliasData} originvalues={anomaliasData} disabledrefresh={true}>
                        {Columns(columnsAnom)}
                    </DataTable>
                </ExPaper>
            </Grid>
        </Grid>
    )
})